import { render, staticRenderFns } from "./MailV2TemplateList.vue?vue&type=template&id=8ea2177c&scoped=true"
import script from "./MailV2TemplateList.vue?vue&type=script&lang=js"
export * from "./MailV2TemplateList.vue?vue&type=script&lang=js"
import style0 from "./MailV2TemplateList.vue?vue&type=style&index=0&id=8ea2177c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea2177c",
  null
  
)

export default component.exports